import { Injectable } from '@angular/core';
import { HashmapStateBase } from 'src/app/shared/state/hashmap-state-base';
import { accountsStateFactory, StateManager } from './accounts-base.state';

@Injectable({
  providedIn: 'root',
})
export class AccountsHashmapState extends HashmapStateBase<StateManager> {
  protected override createState(): StateManager {
    return accountsStateFactory();
  }
}
